import 'bootstrap/dist/css/bootstrap.min.css';
import { React, useEffect, useState, useRef } from 'react';
import Login from './Components/Login.js';
import Search from './Components/Search';
import Header from './Components/Header.js';
import Bags from './Components/Bags.js';
import Seat from './Components/Seat.js';
import Payment from './Components/Payment.js';
import SideMenu from './Components/SideMenu.js';
import PassengerInformation from './Components/PassengerInformation';
import Comments from './Components/Comments.js';
import PnrHistory from './Components/PnrHistory.js';
import { Route, Link, Router, Redirect, HashRouter, BrowserRouter, Switch, useHistory, useLocation, withRouter } from 'react-router-dom';
import SpiceClub from './Components/SpiceClub';
import BagTag from './Components/BagTag';
import Service from './Components/Service';
import Finalize from './Components/Finalize';
import BoardingPass from './Components/BoardingPass';
import NotFound from './Components/NotFound';
import SubHeader from './Components/SubHeader.js';
import LogoutModel from './Components/LogoutModel';
import ManifestDetail from './Components/ManifestDetail';
import ManifestSubHeader from './Components/ManifestSubHeader';
import FlightSearch from './Components/FlightSearch';
import Overview from './Components/Overview';
import Manifest from './Components/Manifest';
import Boarding from './Components/Boarding';
import SeatManagement from './Components/SeatManagement';
import Security from './Components/Security';
import PeripheralDevices from './Components/PeripheralDevices';
import Notification from './Components/Notification';
import { useDispatch, useSelector } from 'react-redux';
import {
  logoutCredential, selectedDestinationDropdownCredential, selectedpassengerCredential
  , searchCredential, PaymentTypeDropdownCredential, FeeServiceDropdownCredential,
  selectedOriginDropdownCredential, setSidemenuFlag, flightManifestDetails, flightSearchCredential,
  flightManifestBoardingCredential,
  flightTripBoardingCredential,
  setflightLegKeyCredential,
  assistQueueCredential, moduleDropdown, redirectToPageCredentials, setPrintMode, FetchPrintModeModalStatus
} from './ReduxState';
import { loginCredential } from './ReduxState';
import Sidebar from './Components/Sidebar.js';
import { fncKeepAliveSession, fncLogoutApi, fncManifestDetails, fncGetTripStatus, fncLoadFlightManifestDataForBoarding, fncSitaFlexGetTokenOrStatus } from './Utility/ApiCall.js'
import { fncRedirectToHome, checkinModule, boardingModule, mapToProp, notificationModule } from './Utility/CommonFun';
import { ToastContainer, toast } from 'react-toastify';
import { useIdleTimer } from 'react-idle-timer'
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import { getConfig } from './config';
export const SessionTimeOut = process.env.REACT_APP_SESSIONTIMEOUT;
import FocusLock from "react-focus-lock";


function App(props) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const ref = useRef();
  // console.log('getConfig().API_URL;', getConfig().API_URL);
  const Location = useSelector(state => state.login.Location);
  // const [triggerModal, settriggerModal] = useState(false);
  const [triggerSessionModal, setSessiontriggerModal] = useState(false);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const manifest = useSelector(state => state.sidemenu.manifestDetails);
  const SearchedRecordData = useSelector(state => state.search.SearchedRecordData);
  const ApplicationTheme = useSelector(state => state.login.Theme);
  const IsLogin = useSelector(state => state.login.IsLogin);
  const UserBoardingRights = useSelector(state => state.login.BoardingRights);
  const UserRights = useSelector(state => state.login.CheckInRights);
  const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
  const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
  const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
  const selectedModule = useSelector(state => state.login.Module);
  const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
  const PrintModeModalStatus = useSelector(state => state.printMode.PrintModeModalStatus); 
  const selectedprintMode = useSelector(state => state.printMode.selectedMode);
      const sitaFlexLocationId = useSelector(state => state.printMode.sitaFlexLocationId);
  // var textEncoder, writableStreamClosed, writer, historyIndex = -1;
  function fncLogout() {
    document.getElementById("showAndHideSpinner").style.display = "block";
    fncLogoutApi()
      .then((returnVal) => {
           
        // localStorage.clear();
        localStorage.removeItem("LoginToken");
        localStorage.removeItem("SITAPrinters");
        dispatch(logoutCredential(
          {
            type: "",
            UserName: "",
            Password: "",
            Role: "",
            Id: 0,
            IsLogin: false
          }));

        dispatch(selectedOriginDropdownCredential(
          {
            type: "",
            OriginDropdown: []
          }))
        dispatch(selectedDestinationDropdownCredential(
          {
            type: "",
            DestinationDropdown: []
          }))

        dispatch(FeeServiceDropdownCredential(
          {
            type: "",
            FeeServiceDropdown: []
          }))
        dispatch(PaymentTypeDropdownCredential(
          {
            type: "",
            PaymentTypeDropdown: []
          }))
        dispatch(searchCredential(
          {
            type: "",
            SearchedRecordData: [],
            SearchedFlightDetails: []
          }));
        dispatch(selectedpassengerCredential(
          {
            type: "",
            SelectedPassengerData: []
          }));
          dispatch(moduleDropdown(
            {
              type:"",
              module: checkinModule
            }
          ));
          dispatch(flightSearchCredential(
            {
                type: "",
                flightList: [],
            }))
            dispatch(flightManifestBoardingCredential(
              {
                  type: '',
                  flightManifestBoarding: null
              }
          ))
          dispatch(flightTripBoardingCredential(
              {
                  type: '',
                  flightTripBoarding: null
              }
          ))
          dispatch(assistQueueCredential(
              {
                  type: "",
                  assistQueue: [],
              }
          ))
          dispatch(setflightLegKeyCredential({
            type: '',
            selectedFlight: null
        }));
        dispatch(redirectToPageCredentials(
                  {
                    type: "",
                    redirectionPage: '/Search'
                  }
                ));
        dispatch(FetchPrintModeModalStatus(
                  {
                    type: "PRINT_MODE_MODAL_STATUS",
                    PrintModeModalStatus: false
                  }
                ));
        dispatch(setPrintMode(
                  {
                    type: "",
                    selectedMode: "Native"
                  }
                ));
        history.push("/");
        document.getElementById("showAndHideSpinner").style.display = "none";
      })
      .catch(err => console.log("Axios err: ", err))
  }

  const onhandleSideMenu = () => {
    if (selectedModule === checkinModule) {
      setOpenSideMenu(!openSideMenu);
    }
  }

  useEffect(() => {
    if (!openSideMenu) return;
    const checkIfClickedOutside = (e) => {
      if (!ref.current) return;
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (e.type === "mousedown" && !ref.current.contains(e.target)) {
        setOpenSideMenu(false);
      }
      if ( e.key === "Enter" || e.key === "Tab"){
        if (!ref.current.contains(document.activeElement)) {
          setOpenSideMenu(false);
        }
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside);
    document.addEventListener("keyup", checkIfClickedOutside);
  
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
      document.removeEventListener("keyup", checkIfClickedOutside);
    };
  }, [openSideMenu, ref]);
  

  const handleOnIdle = event => {
       
    console.log('user is idle', IsLogin, triggerSessionModal)
    if (IsLogin) {
      setSessiontriggerModal(true);
      fncLogout();
    }
    console.log('last active', getLastActiveTime())
  }

  const handleOnActive = event => {
    console.log('user is active', event);
    console.log('time remaining', getRemainingTime());
  }

  const handleOnAction = event => {
    // console.log('user did something', event)
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: (1000 * 60) * parseInt(SessionTimeOut),
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    // debounce: 500
  })

  const handleClose = () => {
    setSessiontriggerModal(false);
  }

  

  useEffect(() => { 
    if (!fncRedirectToHome()) {
      history.push('/');
    }
    // setInterval(function () {
    //   // Invoke function every 10 minutes
    //   console.log('setInterval', triggerSessionModal);
    //   fncSetTimeOut();
    // }, 120000);
    

  }, [history]);

  function fncSetTimeOut() {
    // debugger;
    if(IsLogin == true )
    {
      setSessiontriggerModal(true);
    }
  }

  useEffect(() => {
    const disableConsole = () => {
      // Disable right-click
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
      });

      // Disable some keyboard shortcuts
      document.addEventListener('keydown', (e) => {
        if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) {
          e.preventDefault();
        }
      });
    };

    disableConsole();

    // Cleanup on component unmount
    return () => {
      document.removeEventListener('contextmenu', () => {});
      document.removeEventListener('keydown', () => {});
    };
  }, []);

  useEffect(() => {
    const intervalCall = setInterval(() => {
      console.log('token alive call at every 10 mins', IsLogin)
      if(IsLogin) {
        fncKeepAliveSession();
      }
    }, 600000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, [IsLogin]);

  const showSubHeaders = () => {
    let retValue = false;
    if (selectedModule === checkinModule && location.pathname !== '/Search' && SearchedRecordData.length && SearchedFlightDetails && SearchedFlightDetails.recordLocator) {
      for(let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
        if (SearchedFlightDetails.journeys[i].segments.some(seg => seg.IsSelected)) {
          retValue = true;
          break;
        } else {
          retValue = false;
        }
      }
    }
    else if (selectedModule === boardingModule && location.pathname !== '/FlightSearch' && (flightManifest || flightTripBoarding)) {
      retValue = true;
    }
    return retValue;
  }

  useEffect(() => {
    const intervalCall = setInterval(() => {
      console.log('manifest call at every 30 secs for checkin module', manifest)
      let selectedSegment = [];
      let apiRequest = {};
      // console.log('SearchedRecordData', SearchedRecordData);
      if (selectedModule === checkinModule && SearchedRecordData.length === 1 && SearchedFlightDetails && SearchedFlightDetails.recordLocator) {
        // debugger
        let shouldSkip = false;
        SearchedRecordData.forEach(items => {
                items.passengerData.forEach(p => {
                  if (shouldSkip) {
                    return;
                  }
                  selectedSegment = p.segments.filter(s => s.IsSelected);
                  if (selectedSegment.length) {
                    shouldSkip = true;
                    return;
                  }
                });
        });
        if (selectedSegment.length) {
          apiRequest = {
            LegKey: selectedSegment[0].legs[0].legKey
            // Date: selectedSegment[0].departureTime,
            // DepartureStation: selectedSegment[0].origin,
            // ArrivalStation: selectedSegment[0].destination,
            // FlightNo: selectedSegment[0].flightNumber,
            // CarrierCode: selectedSegment[0].carrierCode
          }
          fncManifestDetails(apiRequest)
          .then((response) => {

            if (response.status == "401" && response.data == "") {
              console.log(response.statusText);
              document.getElementById("showAndHideSpinner").style.display = "none";
              setSessiontriggerModal(true);
            }else {
              if (!response.data.isError) {
                      // console.log('response.data', response);
                      dispatch(flightManifestDetails(
                              {
                                      type: "",
                                      manifestDetails: {
                                              totalManifestCounts: response.data.totalManifestCounts,
                                              passengerSummaries: response.data.passengerSummaries
                                      }
                              }
                      ));
              } else {
                      // notify(response.data.errorDetail.errorMessage);
                      console.log(response.data.errorDetail);
              }
          }
          })
        }
      }
    }, 30000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, [manifest]);

  const serialResultsDiv = document.getElementById("text");

  useEffect(() => {
    const intervalCall = setInterval(async () => {
      console.log('manifest call at every 60 secs')
      
      // console.log('SearchedRecordData', SearchedRecordData);
      if (selectedModule === boardingModule && selectedLeg) {
        // debugger
        try {
          console.log('manifest call at every 60 secs for selectedLeg', selectedLeg);
            const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg, true);
            const tripData = await fncGetTripStatus(selectedLeg, true);
            if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
              console.log(manifestData.statusText);
              document.getElementById("showAndHideSpinner").style.display = "none";
              setSessiontriggerModal(true);
            } else {
                if (!manifestData.data.isError) {
                    const { passengerList } = manifestData.data.data;
                    const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                    passengerList.length && passengerList.forEach(pax => {
                        pax.isChecked = false;
                        pax.isSelectedForSeatAssign = false;
                        pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                    });
                    dispatch(flightManifestBoardingCredential(
                        {
                            type: '',
                            flightManifestBoarding: manifestData.data.data
                        }
                    ))

                } else {
                    // document.getElementById("showAndHideSpinner").style.display = "none";
                    console.log(manifestData.data.errorDetail.errorMessage);
                }

                if (!tripData.data.isError) {
                    const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                    dispatch(flightTripBoardingCredential(
                        {
                            type: '',
                            flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                        }
                    ))
                } else {
                    // document.getElementById("showAndHideSpinner").style.display = "none";
                    console.log(tripData.data.errorDetail.errorMessage);
                }
                // document.getElementById("showAndHideSpinner").style.display = "none";
                dispatch(setflightLegKeyCredential({
                    type: '',
                    selectedFlight: selectedLeg
                }));
                // const navPage = pageNavigationForBoardingModule('FlightSearch');
                // history.push("/"+navPage);          
            }
        } catch (e) {
            console.log('error in loading flight manifest for boarding module data', e);
            // document.getElementById("showAndHideSpinner").style.display = "none";
            // notify(e.message);
        }
      }
    }, 60000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, [selectedLeg, selectedModule]);

  useEffect(() => {
    const preventF7Popup = (event) => {
      if (event.key === "F7" || event.key === "F3" || event.key === "F5" || event.key === "F10" || event.key === "F6" ) {
        event.preventDefault(); // Prevents the Caret Browsing pop-up
      }
      if((event.altKey && event.key.toLowerCase() === "e" ) || (event.ctrlKey && event.key === "d") || (event.ctrlKey && event.key === "p") || (event.ctrlKey && event.key === "h")){
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", preventF7Popup);

    return () => {
      document.removeEventListener("keydown", preventF7Popup);
    };
  }, []);

  useEffect(() => {
    const intervalCall = setInterval(async () => {
      console.log('sita flex token call at every 25mins');
      if (selectedprintMode === 'SITA FLEX' && sitaFlexLocationId !== '') {
        fncSitaFlexGetTokenOrStatus({
          LocationId: sitaFlexLocationId,
          Type: "RT" 
          })
          .then((response) => {
              console.log('fncMBPDetails', response);
              if (response.status == "401" && response.data == "") {
                  document.getElementById("showAndHideSpinner").style.display = "none";
                  settriggerModal(true);
              } else {
                  if (response.status == 200) {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    console.log('returnVal.data', response.data);
                    localStorage.setItem('SITAPrinters', JSON.stringify(response.data));
                  } else {
                      document.getElementById("showAndHideSpinner").style.display = "none";
                      const dummy = [ 

                          { 
                          
                          "deviceId": "A-JAF-JAF1WLB006.ATB1", 
                          
                            "deviceStatus": "Online", 
                          
                          "mediaStatus": "Ok", 
                          
                          "binStatus": "Ok" 
                          
                          }, 
                          
                          { 
                          
                            "deviceId": "A-JAF-JAF1WLB006.BTP1", 
                          
                            "deviceStatus": "Online", 
                          
                            "mediaStatus": "Ok", 
                          
                            "binStatus": "Ok" 
                          
                          } 
                          
                          ]

                          // setsitaFlexPrinter(dummy);
                          localStorage.setItem('SITAPrinters', JSON.stringify(dummy));
                      // if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                      //   settriggerModal(true);
                      // } else {
                      //   notify(returnVal.data.errorDetail.errorMessage);
                      // }
                  }
              }
              
            })
            .catch((err) => {
              console.log("Axios err in fncSitaFlexGetTokenOrStatus: ", err);
              // notify('Something went wrong. Please try again after sometime.', 3000);
            });
      }
    }, 1500000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, []);

  try {

    return (
      <FocusLock>

      <HashRouter>
        <LogoutModel trigger={triggerSessionModal}> </LogoutModel>
        {/* <SessionTimeOutModel
        trigger={triggerSessionModal}
        handleClose={handleClose}
        >
        </SessionTimeOutModel> */}
        <ToastContainer />
        <Switch>
          {
            IsLogin == false ?
              <div className="container-fluid">
                <Route exact path='/' component={Login} />
              </div>
              :
              <Switch>
                {/* <Route path='/Search' render={(props) => <Search handleSideMenu={onhandleSideMenu}  />} />  */}
                {/* <Route key={Header} path='/Header' component={Header} /> */}
                {/* <Route key={Search} path='/Search' component={Search} /> */}
                <div >
                  <div ref={ref}>
                    
                  <Route key={BagTag} path='/BagTag' render={(props) => <BagTag {...props}/>}/>
                  <SideMenu openSideMenu={openSideMenu} handleSideMenu={onhandleSideMenu} />
                   
                  </div>
                  <div>
                    <Header handleSideMenu={onhandleSideMenu} />
                    {showSubHeaders() ?
                    <div>
                    <SubHeader /> 
                    { selectedModule === checkinModule ? <ManifestSubHeader /> : null }
                    </div>
                    : null}
                  </div>
                  <main class="col-12">
                  <Route key={PassengerInformation} path='/PassengerInformation' render={(props) => ( <PassengerInformation {...props} handleSideMenu={onhandleSideMenu}/>)}/>
                  <Route key={PnrHistory} path='/PnrHistory' render={(props) => ( <PnrHistory {...props} handleSideMenu={onhandleSideMenu}/>)}/>
                  <Route key={Comments} path='/Comments' render={(props) => ( <Comments {...props} handleSideMenu={onhandleSideMenu} />)}/>
                  <Route key={PeripheralDevices} path='/PeripheralDevices' render={(props) => ( <PeripheralDevices {...props} handleSideMenu={onhandleSideMenu} />)}/>
                    <div >
                      <div >
                        <div id="IDMainBody" >
                          <div >
                              { selectedModule === checkinModule && UserRights && UserRights.length !==0 ? UserRights.map((item) => (
                                item.key.toUpperCase() == "Bags".toUpperCase() ?
                                  <Route key={Bags} path='/Bags' render={(props) => <Bags handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Bags}
                                  item.key.toUpperCase() == "Search".toUpperCase() ?
                                  <Route exact key={Search} path='/Search' render={(props) => <Search handleSideMenu={onhandleSideMenu} {...props} />} /> : //component={Search}
                                  item.key.toUpperCase() == "Seat".toUpperCase() ?
                                    <Route key={Seat} path='/Seat' render={(props) => <Seat handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Seat}
                                    item.key.toUpperCase() == "Payment".toUpperCase() ?
                                      <Route key={Payment} path='/Payment' render={(props) => <Payment handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Payment}
                                      item.key.toUpperCase() == "SpiceClub".toUpperCase() ?
                                        <Route key={SpiceClub} path='/SpiceClub' render={(props) => <SpiceClub handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={SpiceClub}
                                        item.key.toUpperCase() == "Service".toUpperCase() ?
                                          <Route key={Service} path='/Service' render={(props) => <Service handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Service}
                                          item.key.toUpperCase() == "Finalize".toUpperCase() ?
                                            <Route key={Finalize} path='/Finalize' render={(props) => <Finalize handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Finalize}
                                            item.key.toUpperCase() == "SecurityTravelDoc".toUpperCase() ?
                                          <Route key={Security} path='/SecurityTravelDoc' render={(props) => <Security handleSideMenu={onhandleSideMenu} {...props} />}  /> : //component={Security}
                                            ""
                              )) :
                              selectedModule === boardingModule && UserBoardingRights && UserBoardingRights.length !==0 ? 
                              UserBoardingRights.map((item) => (
                                  item.key.toUpperCase() === "FlightSearch".toUpperCase() ?
                                  <Route exact key={FlightSearch} path='/FlightSearch' component={FlightSearch} /> :
                                  item.key.toUpperCase() == "SeatManagement".toUpperCase() ?
                                    <Route key={SeatManagement} path='/SeatManagement' component={SeatManagement} /> :
                                    item.key.toUpperCase() === "Overview".toUpperCase() ?
                                      <Route key={Overview} path='/Overview' component={Overview} /> :
                                      item.key.toUpperCase() === "Manifest".toUpperCase() ?
                                        <Route key={Manifest} path='/Manifest' component={Manifest} /> :
                                        item.key.toUpperCase() == "Boarding".toUpperCase() ?
                                          <Route key={Boarding} path='/Boarding' component={Boarding} /> :
                                            ""
                              ))
                              :
                              selectedModule === notificationModule ?
                              <Route key={Notification} path='/Notification' component={Notification} />
                              : null }
                              {/* <Route key={PassengerInformation} path='/PassengerInformation' component={PassengerInformation} />                          */}
                              <Route key={BoardingPass} path='/BoardingPass' component={BoardingPass} />
                              {/* <Route key={ManifestDetail} path='/ManifestDetail' component={ManifestDetail} /> */}
                              <Route key="ManifestDetail" path="/ManifestDetail" render={(props) => (<ManifestDetail {...props} handleSideMenu={onhandleSideMenu} />)}/>

                              {/* <Route key={Security} path='/Security' component={Security} /> */}
                              {/* <Route key={SubHeader} path='/SubHeader' component={SubHeader} /> */}
                              {/* <Route path='/ManifestSubHeader' component={ManifestSubHeader} /> */}
                              {/* <Route key={BagTag} path='/BagTag' component={BagTag} /> */}
                              {/* <Route key={Search} path='/Search' component={Search} /> */}
                              {/* <Route key="NotFound" exact path='/' component={NotFound} /> */}
                              
                              <Route
                                exact
                                path="/"
                                render={() => {
                                    return (
                                      IsLogin && selectedModule === checkinModule && UserRights && UserRights.length !==0 ?
                                      <Redirect to="/Search" /> :
                                      IsLogin && selectedModule === boardingModule && UserBoardingRights && UserBoardingRights.length !==0 ?
                                      <Redirect to="/FlightSearch" /> :
                                      null
                                    )
                                }}
                              />
                              <Route key={Login} path='/Login' component={Login} />
                            </div>
                        </div>
                      </div>
                    </div>
                  </main>
                </div>
                {/* <Route key={Search} exact path='/Search' component={Search} /> */}
                {/* <Route path="*" component={NotFound} /> */}
              </Switch>
          }
        </Switch>
      </HashRouter>
      </FocusLock>

    );
  }
  catch (error) {
    console.log(error);
  }
}
export default withRouter(App);